// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once embed editors use sp apps.
import { createApiClient } from "#/shared/api/client";

/** Creates a client for rendering embed previews from form data. */
export function createEmbedPreviewApi() {
  const client = createApiClient({ parse: false, baseURL: location.origin, headers: { Accept: "text/html" } });

  return {
    render(endpoint, body, { signal } = {}) {
      return client.request("post", endpoint, { data: body, signal });
    },
  };
}
